// @flow
import type { Action } from './store.type';

export const SEARCH_FEATURES_PREVIEW_REQUEST = 'SEARCH_FEATURES_PREVIEW_REQUEST';
type SEARCH_FEATURES_PREVIEW_REQUEST_TYPE = 'SEARCH_FEATURES_PREVIEW_REQUEST';
export const SEARCH_FEATURES_PREVIEW_SUCCESS = 'SEARCH_FEATURES_PREVIEW_SUCCESS';
type SEARCH_FEATURES_PREVIEW_SUCCESS_TYPE = 'SEARCH_FEATURES_PREVIEW_SUCCESS';
export const SEARCH_FEATURES_PREVIEW_FAILURE = 'SEARCH_FEATURES_PREVIEW_FAILURE';
type SEARCH_FEATURES_PREVIEW_FAILURE_TYPE = 'SEARCH_FEATURES_PREVIEW_FAILURE';

// Check live theme supported
type SearchFeaturesPreviewSuccess = {};
type SearchFeaturesPreviewFailure = {
  error: any
};
type SearchFeaturesPreviewRequestAction = Action<SEARCH_FEATURES_PREVIEW_REQUEST_TYPE, null>;
type SearchFeaturesPreviewSuccessAction = Action<
  SEARCH_FEATURES_PREVIEW_SUCCESS_TYPE,
  SearchFeaturesPreviewSuccess
>;
type SearchFeaturesPreviewFailureAction = Action<
  SEARCH_FEATURES_PREVIEW_FAILURE_TYPE,
  SearchFeaturesPreviewFailure
>;
export type SearchFeaturesPreviewAction =
  | SearchFeaturesPreviewRequestAction
  | SearchFeaturesPreviewSuccessAction
  | SearchFeaturesPreviewFailureAction;

export type SearchFeaturesPreviewState = {
  loading: boolean,
  success: boolean,
  error: boolean,
  features: {}
};
